<template>
	<map-marker :lat-lng="[event.lat, event.lng]" :title="event.display_name"
				:color="event.color"
				:height="markerSize / (3/2)"
				:width="markerSize"
				tile
				:draggable="draggable"
				@moved="latLng => emit('moved', latLng)"
				@click="latLng => emit('click', latLng)"
				:image="$image.format(event.avatar_thumbnail, {width: (markerSize * 2), height: (markerSize * 2) / (3/2)})"/>
</template>

<script setup lang="ts">
import type {MapModel} from "../../types/map";

const props = defineProps<{
	event: MapModel,
	to?: string | object,
	draggable?: boolean,
}>();

const markerSize = props.event.managed ? 48 : 40;

const emit = defineEmits(['click', 'moved']);

</script>
